import { memo } from 'react';

import { Card, Flex, List } from 'antd';

import styles from './styles.module.scss';

import GeofenceDetailsListItem from './GeofenceDetailsListItem';
import usePreparedGeofenceData from './usePreparedGeofenceData';

function GeofenceDetails({ geofence }) {
  const geofenceArray = Array.isArray(geofence) ? geofence : [geofence];
  const name = geofence?.is_master ? geofence?.farm?.name : geofence?.name;
  const { columnOneData } = usePreparedGeofenceData({ geofence });

  return (
    <Card title={`Pasture ${name} Details`} className="mb-2">
      <Flex className="w-full" gap="middle" wrap>
        <List
          className={styles.details}
          size="small"
          dataSource={geofenceArray}
          renderItem={() => (
            <>
              {columnOneData
                ?.filter(item => item.isVisible)
                ?.map(item => (
                  <GeofenceDetailsListItem key={item.label} label={item.label} value={item.value} />
                ))}
            </>
          )}
        />
      </Flex>
    </Card>
  );
}

export default memo(GeofenceDetails);
